import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import QuickMessageButton from '../QuickMessageButton';
import { ArrowLeft, PlayCircle, PauseCircle, StopCircle, Activity, Radio } from 'lucide-react';

export function ExerciseHeader({
  exercise, exerciseId, navigate,
  isController, isObserver, canManageExercise,
  handleControlAction, setEndConfirmOpen, setStatusChangeOpen,
  getStatusBadgeClass,
}) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" onClick={() => navigate('/exercises')}>
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <div>
          <div className="flex items-center gap-2">
            <h1 className="font-secondary font-bold text-2xl">{exercise.name}</h1>
            <Badge className={`${getStatusBadgeClass(exercise.status)} border capitalize`}>
              {exercise.status}
            </Badge>
          </div>
          <p className="text-sm text-muted-foreground capitalize">
            {exercise.exercise_type} Exercise
          </p>
        </div>
      </div>
      
      <div className="flex gap-2 flex-wrap">
        {(isController() || isObserver()) && (
          <QuickMessageButton exerciseId={exerciseId} exerciseName={exercise.name} />
        )}
        {isController() && (
          <Button
            variant="outline"
            onClick={() => navigate(`/exercises/${exerciseId}/preflight`)}
            data-testid="preflight-btn"
            title="Run pre-flight diagnostics"
          >
            <Activity className="w-4 h-4 mr-2" />
            Pre-flight
          </Button>
        )}
        {isController() && exercise.status === 'active' && (
          <Button
            variant="default"
            onClick={() => navigate(`/exercises/${exerciseId}/live`)}
            data-testid="live-workshop-btn"
            title="Open live workshop war-room dashboard"
            className="bg-emerald-600 hover:bg-emerald-700"
          >
            <Radio className="w-4 h-4 mr-2 animate-pulse" />
            Live
          </Button>
        )}
        {isController() && (
          <>
            {exercise.status === 'draft' && (
              <Button onClick={() => handleControlAction('start')} data-testid="start-exercise-btn">
                <PlayCircle className="w-4 h-4 mr-2" />
                Start Exercise
              </Button>
            )}
            {exercise.status === 'active' && (
              <>
                <Button variant="outline" onClick={() => handleControlAction('pause')}>
                  <PauseCircle className="w-4 h-4 mr-2" />
                  Pause
                </Button>
                <Button variant="destructive" onClick={() => setEndConfirmOpen(true)}>
                  <StopCircle className="w-4 h-4 mr-2" />
                  End
                </Button>
                <Button asChild>
                  <Link to={`/control-room/${exerciseId}`}>
                    Control Room
                  </Link>
                </Button>
              </>
            )}
            {exercise.status === 'planned' && (
              <Button onClick={() => handleControlAction('resume')}>
                <PlayCircle className="w-4 h-4 mr-2" />
                Resume
              </Button>
            )}
            {exercise.status === 'completed' && (
              <Button variant="outline" onClick={() => setStatusChangeOpen(true)}>
                <PlayCircle className="w-4 h-4 mr-2" />
                Reactivate
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
